export default __webpack_public_path__ + "static/media/gatsby.71556924.png";